import type {
  ContractorDocumentAPI,
  CreateDocumentRequest,
} from '../../contractorDocuments';
import type {
  ContractorPayment,
  ContractorPaymentAPI,
  ContractorPaymentQuote,
  ContractorPaymentQuoteAPI,
} from '../../contractorPayments';
import type {
  ContractorInvoice,
  PermittedInvoiceCurrenciesEnum,
} from '../contractorInvoices';

/**
 * API
 */
export enum ContractorInvoiceStateEnumAPI {
  CANCELLED = 'CANCELLED',
  IN_PROGRESS = 'IN_PROGRESS',
  OPEN = 'OPEN',
  PAID = 'PAID',
  REJECTED = 'REJECTED',
}

export type ContractorInvoiceAPI = {
  id: string;
  state: ContractorInvoiceStateEnumAPI;
  contractor: {
    id: string;
    name: string;
  };
  client: {
    id: string;
    name: string;
  };
  amount: string;
  currency: PermittedInvoiceCurrenciesEnum;
  due_date: string;
  description: string;
  raised_at: string;
  paid_at?: string;
  overdue_by?: string;
  invoice_ref: string;
  attachments?: ContractorDocumentAPI[];
  payment_id?: string;
  billing_currency: PermittedInvoiceCurrenciesEnum;
};

export type GetContractorInvoicesResponseAPI = {
  items: ContractorInvoiceAPI[];
  total: number;
  page: number;
  size: number;
  pages: number;
};

export type GetContractorInvoiceResponseAPI = ContractorInvoiceAPI;

export type CreateInvoiceRequestAPI = {
  invoice_ref: string;
  currency: string;
  amount: string;
  due_date: string;
  description: string;
  attachments?: CreateDocumentRequest[];
};

export type CreateInvoiceQuoteRequestAPI = {
  invoices: string[];
  allow_partial_payment?: boolean;
};

export type CreateInvoiceQuoteResponseAPI = ContractorPaymentQuoteAPI;

export type CreateInvoicePaymentRequestAPI = {
  quote_id: string;
};

export type CreateInvoicePaymentResponseAPI = ContractorPaymentAPI;

/**
 * Model
 */

export type GetContractorInvoiceResponse = ContractorInvoice;

export type GetContractorInvoicesResponse = {
  items: ContractorInvoice[];
  total: number;
  page: number;
  size: number;
  pages: number;
};

export type CreateInvoiceRequest = {
  invoiceRef: string;
  currency: string;
  amount: string;
  dueDate: string;
  description: string;
  attachments?: CreateDocumentRequest[];
};

export type CreateInvoiceQuoteRequest = {
  invoices: string[];
  allowPartialPayment?: boolean;
};

export type CreateInvoiceQuoteResponse = ContractorPaymentQuote;

export type CreateInvoicePaymentRequest = {
  quoteId: string;
};

export type CreateInvoicePaymentResponse = ContractorPayment;
